// extracted by mini-css-extract-plugin
module.exports = {"root":"create-item-page_root__3mSU3","submission":"create-item-page_submission__16RVA","button":"create-item-page_button__19SdQ"};